// Components/ProvinceSelector.js
import React from 'react';

const provinces = [
  'Bohol',
];

const ProvinceSelector = ({ formData, setFormData, darkMode }) => {
  const handleProvinceChange = (e) => {
    setFormData({
      ...formData,
      province: e.target.value,
    });
  };

  return (
    <select
      id="province"
      name="province"
      className="form-control"
      value={formData.province}
      onChange={handleProvinceChange}
      style={{
        padding: '5px',
        borderRadius: '6px',
        border: '1px solid',
        backgroundColor: darkMode ? '#dcdcdc' : '#f2f2f2',
        color: '#333',
      }}
    >
      <option value="">Select Province</option>
      {provinces.map((province) => (
        <option key={province} value={province}>
          {province}
        </option>
      ))}
    </select>
  );
};

export default ProvinceSelector;
